/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_Qc_ReviewInputs */

const en_quicktools_tab_qc_review = /** @type {(inputs: Quicktools_Tab_Qc_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QC & Review`)
};

const fr_quicktools_tab_qc_review = /** @type {(inputs: Quicktools_Tab_Qc_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QC et revision`)
};

const de_quicktools_tab_qc_review = /** @type {(inputs: Quicktools_Tab_Qc_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualitätskontrolle und Überprüfung`)
};

const it_quicktools_tab_qc_review = /** @type {(inputs: Quicktools_Tab_Qc_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controllo qualità e revisione`)
};

const ru_quicktools_tab_qc_review = /** @type {(inputs: Quicktools_Tab_Qc_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контроль качества и проверка`)
};

const es_quicktools_tab_qc_review = /** @type {(inputs: Quicktools_Tab_Qc_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Control de calidad y revisión`)
};

const zh_cn2_quicktools_tab_qc_review = /** @type {(inputs: Quicktools_Tab_Qc_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`质量控制与审核`)
};

const ja_quicktools_tab_qc_review = /** @type {(inputs: Quicktools_Tab_Qc_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QCとレビュー`)
};

const hi_quicktools_tab_qc_review = /** @type {(inputs: Quicktools_Tab_Qc_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गुणवत्ता नियंत्रण और समीक्षा`)
};

const pt_pt2_quicktools_tab_qc_review = /** @type {(inputs: Quicktools_Tab_Qc_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controle de Qualidade e Revisão`)
};

/**
* | output |
* | --- |
* | "QC & Review" |
*
* @param {Quicktools_Tab_Qc_ReviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_qc_review = /** @type {((inputs?: Quicktools_Tab_Qc_ReviewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_Qc_ReviewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_quicktools_tab_qc_review(inputs)
	if (locale === "de") return de_quicktools_tab_qc_review(inputs)
	if (locale === "it") return it_quicktools_tab_qc_review(inputs)
	if (locale === "ru") return ru_quicktools_tab_qc_review(inputs)
	if (locale === "es") return es_quicktools_tab_qc_review(inputs)
	if (locale === "zh-CN") return zh_cn2_quicktools_tab_qc_review(inputs)
	if (locale === "ja") return ja_quicktools_tab_qc_review(inputs)
	if (locale === "hi") return hi_quicktools_tab_qc_review(inputs)
	if (locale === "pt-PT") return pt_pt2_quicktools_tab_qc_review(inputs)
	return en_quicktools_tab_qc_review(inputs)
});